import { Injectable, EventEmitter } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { filter, map } from "rxjs/operators";

import * as Cookies from "js-cookie";

interface Message {
  type: string;
  payload?: any;
}

@Injectable({ providedIn: "root" })
export class Events {
  static cyclePageDidMount = new EventEmitter<string>();
  static myProjectsDidCount = new EventEmitter<number>();
  static myProjectsStudentDidCount = new EventEmitter<number>();
  static voucherDidCalculate = new EventEmitter<number>();
  static isSuperuserMenuItem = new EventEmitter<any>();
  static isInstutitionMenuItem = new EventEmitter<any>();
  static institutionName = new EventEmitter<string>();
  static currentRepositoryId = new EventEmitter<string>();
  static currentProjectId = new EventEmitter<number>();
  static editorStatusLabel = new EventEmitter<string>();
  static showEditorLabel = new EventEmitter<boolean>();
  static selectedPlan = new EventEmitter<any>();

  private hanlder: Subject<Message>;

  constructor() {
    this.hanlder = new Subject<Message>();
  }

  setVoucherExpiresAt(voucher_expires_at: number): void {
    Events.voucherDidCalculate.emit(voucher_expires_at);
  }

  setMyProjectsTotal(total: number): void {
    Events.myProjectsDidCount.emit(total);
  }

  setProjectsMyStudentTotal(total: number): void {
    Events.myProjectsStudentDidCount.emit(total);
  }

  setPlaylistUrl(url: string): void {
    Events.cyclePageDidMount.emit(url);
  }

  setAdminMenuItem() {
    Cookies.set("is_superuser", "yes");
    Events.isSuperuserMenuItem.emit();
  }

  setInstitutionMenuItem() {
    Cookies.set("is_institution", "yes");
    Events.isInstutitionMenuItem.emit();
  }

  setCurrentRepositoryId(repositoryId: number): void {
    Cookies.set("current_repository", repositoryId.toString());
    Events.currentRepositoryId.emit();
  }

  setCurrentProjectId(projectId: number): void {
    Events.currentProjectId.emit(projectId);
  }

  setInstitutionName(name: string) {
    Events.institutionName.emit(name);
  }

  setEditorStatusLabel(status: string) {
    Events.editorStatusLabel.emit(status);
  }

  setEditorLabelVisible(visible: boolean) {
    Events.showEditorLabel.emit(visible);
  }

  setSelectedPlan(plan: any) {
    Events.selectedPlan.emit(plan);
  }

  broadcast(type: string, payload?: any) {
    this.hanlder.next({ type: type, payload: payload });
  }

  on<T>(type: string): Observable<T> {
    return this.hanlder.asObservable().pipe(
      filter((event) => event.type === type),
      map((event) => event.payload)
    );
  }
}
